import styled from 'styled-components';

export default styled.div`
  font-size: 1.125rem;
  margin-right: 0.3rem;
  text-decoration: line-through;
  line-height: 2.5;
`;
